import { gql } from 'graphql-tag';
export const CART_DETAILS = gql `
  fragment CartDetails on Cart {
    id
    lines(first: 250) {
      edges {
        node {
          id
          quantity
          merchandise {
            ... on ProductVariant {
              id
              title
              priceV2 {
                amount
              }
              image {
                id
                altText
              }
              product {
                title
                images(first: 5) {
                  edges {
                    node {
                      id
                      originalSrc
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    checkoutUrl
    estimatedCost {
      totalAmount {
        amount
      }
    }
  }
`;
export const CREATE_CART = gql `
  mutation createCart($merchandiseId: ID!) {
    cartCreate(input: { lines: [{ merchandiseId: $merchandiseId }] }) {
      cart {
        ...CartDetails
      }
    }
  }
  ${CART_DETAILS}
`;
export const READ_CART = gql `
  query readCart($cartId: ID!) {
    cart(id: $cartId) {
      ...CartDetails
    }
  }
  ${CART_DETAILS}
`;
export const ADD_TO_CART = gql `
  mutation cartLinesAdd($merchandiseId: ID!, $cartId: ID!) {
    cartLinesAdd(lines: [{ merchandiseId: $merchandiseId }], cartId: $cartId) {
      cart {
        ...CartDetails
      }
    }
  }
  ${CART_DETAILS}
`;
export const REMOVE_FROM_CART = gql `
  mutation cartLinesRemove($lineId: ID!, $cartId: ID!) {
    cartLinesRemove(lineIds: [$lineId], cartId: $cartId) {
      cart {
        ...CartDetails
      }
    }
  }
  ${CART_DETAILS}
`;
